<div
  class="chat-icon bg-red-600 hover:bg-red-500 cursor-pointer"
  (click)="toggleChat()"
>
  <fa-icon
    [icon]="faCommentDots"
    class="text-white"
    [ngClass]="isNarrowerView() ? 'text-2xl' : 'text-4xl'"
  ></fa-icon>
</div>

@if (showChat) {
  <div class="chat-window bg-white shadow-lg rounded-2xl text-xl">
    <div class="bg-red-600 text-white p-2 rounded-t-2xl text-center">
      <div class="font-bold text-3xl py-2">{{ "chat.title" | translate }}</div>
      <div>{{ "chat.message" | translate }}</div>
      <div>{{ "chat.response" | translate }}</div>
    </div>
    <div class="chat-body p-4">
      <form [formGroup]="formGroup" (submit)="sendMessage()">
        <app-text-input
          [control]="formGroup.get('name')!"
          [placeholder]="'chat.form.name' | translate"
        ></app-text-input>
        <app-text-input
          [control]="formGroup.get('email')!"
          [placeholder]="'chat.form.email' | translate"
        ></app-text-input>
        <app-text-input
          [control]="formGroup.get('message')!"
          [placeholder]="'chat.form.message' | translate"
          [isTextArea]="true"
        ></app-text-input>
        <div>
          <select
            formControlName="category"
            required
            class="p-2 bg-white rounded w-full"
            [ngClass]="
              formGroup.get('category')?.value ? '!border-green-600' : ''
            "
          >
            <option value="" disabled [selected]="true">
              {{ "chat.form.categoryLabel" | translate }}:
            </option>
            <option>{{ "chat.form.categories.payment" | translate }}</option>
            <option>
              {{ "chat.form.categories.movieCreation" | translate }}
            </option>
            <option>{{ "chat.form.categories.other" | translate }}</option>
          </select>
        </div>
        <button
          type="submit"
          class="text-white font-bold py-2 px-4 rounded my-2"
          [ngClass]="
            formGroup.valid ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-400'
          "
          [disabled]="!formGroup.valid"
        >
          {{ "chat.form.send" | translate }}
        </button>
      </form>
    </div>
  </div>

  <div
    class="chat-icon bg-red-600 hover:bg-red-500 cursor-pointer"
    (click)="toggleChat()"
  >
    <fa-icon
      [icon]="faXMark"
      class="text-white"
      [ngClass]="isNarrowerView() ? 'text-2xl' : 'text-4xl'"
    ></fa-icon>
  </div>
}
